// extracted by mini-css-extract-plugin
export var allExamples = "exampleSection-module--allExamples--9086c";
export var category = "exampleSection-module--category--729ee";
export var example = "exampleSection-module--example--f1f27";
export var title = "exampleSection-module--title--52117";
export var wrapper = "exampleSection-module--wrapper--99f5b";